// extracted by mini-css-extract-plugin
var _1 = "TestSingleChoiceElement_active__fea0b";
var _2 = "TestSingleChoiceElement_dnd__ab978";
var _3 = "TestSingleChoiceElement_show__ee4f7";
var _4 = "TestSingleChoiceElement_wrapItem__12807";
export { _1 as "active", _2 as "dnd", _3 as "show", _4 as "wrapItem" }
